@if (loading()) {
  <div
    class="eventq-resolve-queue-row eventq-resolve-queue-row--skeleton eventq-resolve-queue-row--accented"
    [style]="rowStyle()"
    aria-hidden="true"
  >
    <div class="eventq-resolve-queue-row__skeleton-lines">
      <span class="eventq-resolve-queue-row__skeleton-block eventq-resolve-queue-row__skeleton-block--title"></span>
      <span class="eventq-resolve-queue-row__skeleton-block eventq-resolve-queue-row__skeleton-block--meta"></span>
    </div>
    <span class="eventq-resolve-queue-row__skeleton-block eventq-resolve-queue-row__skeleton-block--time"></span>
  </div>
} @else if (clickable()) {
  <button
    type="button"
    class="eventq-resolve-queue-row eventq-resolve-queue-row--accented"
    [style]="rowStyle()"
    (click)="onActivate()"
  >
    <div class="eventq-resolve-queue-row__main">
      <div class="eventq-resolve-queue-row__site">
        <span class="eventq-resolve-queue-row__site-name">{{ siteName() }}</span>
        @if (siteCode()) {
          <span class="eventq-resolve-queue-row__site-code">{{ siteCode() }}</span>
        }
      </div>
      <span class="eventq-resolve-queue-row__event-type">{{ eventType() }}</span>
      @if (metaLine(); as meta) {
        <span class="eventq-resolve-queue-row__meta">{{ meta }}</span>
      }
    </div>
    <time class="eventq-resolve-queue-row__timestamp">{{ timestamp() }}</time>
  </button>
} @else {
  <div class="eventq-resolve-queue-row eventq-resolve-queue-row--accented" [style]="rowStyle()">
    <div class="eventq-resolve-queue-row__main">
      <div class="eventq-resolve-queue-row__site">
        <span class="eventq-resolve-queue-row__site-name">{{ siteName() }}</span>
        @if (siteCode()) {
          <span class="eventq-resolve-queue-row__site-code">{{ siteCode() }}</span>
        }
      </div>
      <span class="eventq-resolve-queue-row__event-type">{{ eventType() }}</span>
      @if (metaLine(); as meta) {
        <span class="eventq-resolve-queue-row__meta">{{ meta }}</span>
      }
    </div>
    <time class="eventq-resolve-queue-row__timestamp">{{ timestamp() }}</time>
  </div>
}
